import type { AreaSummaryRow } from './computeSummaryReport';

/** Categorical palette size — chart-1..6 then chart-9..12, i.e. 10 colours (chart-7/8 are reserved for Plan vs Actual). */
export const AREA_SLICE_PALETTE_SIZE = 10;

export interface AreaSlice {
  crop: string;
  areaHa: number;
  /** Share of the total area in scope (0–100) — slices always add up to 100. */
  pct: number;
  /** 0-based position in the 10-colour categorical palette. */
  paletteIndex: number;
  /** True once the palette has been used up — the colour repeats as a lighter variant, so every crop still has its own slice. */
  isVariant: boolean;
}

/**
 * One donut slice per crop, in table order — never folded into "Other".
 * Percentages are shares of the scope's own total area, so they add up to
 * 100 at org, farm and crop scope alike.
 */
export const computeAreaSlices = (rows: AreaSummaryRow[]): AreaSlice[] => {
  const totalHa = rows.reduce((sum, row) => sum + row.areaHa, 0);
  if (totalHa <= 0) return [];
  return rows.map((row, i) => ({
    crop: row.crop,
    areaHa: row.areaHa,
    pct: (row.areaHa / totalHa) * 100,
    paletteIndex: i % AREA_SLICE_PALETTE_SIZE,
    isVariant: i >= AREA_SLICE_PALETTE_SIZE,
  }));
};
